import { NewCareMapWizard } from '../wizards/NewCareMapWizard';
import { IMiniWizardProvider } from './IMiniWizardProvider';

export class CompositeWizardProvider {
    static inject = () => [NewCareMapWizard];
    private wizards: IMiniWizardProvider[];
    constructor(...miniWizards: IMiniWizardProvider[]){
        this.wizards = miniWizards;
    }

    create = (wizardKey: string) => {
        return this.getWizard(wizardKey).create();
    };

    private getWizard = (wizardKey: string): IMiniWizardProvider => {
        const wizard = this.wizards.find(w => w.wizardKey === wizardKey);
        if(!wizard){
            throw new Error(`could not find a wizard for ${wizardKey}`);
        }
        return wizard;
    };
}
